import React, { useEffect, useState } from 'react'

interface TypingEffectProps {
    text: string
    speed?: number
}

const TypingEffect: React.FC<TypingEffectProps> = ({ text, speed = 30 }) => {
    const [displayed, setDisplayed] = useState<string>('')

    useEffect(() => {
        if (!text) {
            setDisplayed('')
            return
        }
        setDisplayed('')
        let index = 0
        const interval = setInterval(() => {
            if (index < text.length) {
                setDisplayed(text.slice(0, index + 1))
                index++
            } else {
                clearInterval(interval)
            }
        }, speed)
        return () => clearInterval(interval)
    }, [text, speed])

    return <>{displayed}</>
}

export default TypingEffect
